import React, { useEffect, useState } from 'react'
import { editAlbum, getAlbum, deleteAlbum, getAlbumPosts, clearAlbumPosts } from '../../actions/userActions'
import { connect } from 'react-redux'
//import audio from '../../img/editar.svg';
import audio from '../../assets/img/audio.png'
import inMemoryJWT from '../../auth/inMemoryJwt';
import { PlusIcon } from '../../assets/icons'
import ModalNewPost from '../../containers/ModalNewPost'
import localStorage from '../../utils/hooks/useLocalStorage'

const Album = ({ match,clearAlbumPosts, getAlbum, location, history, albumInfo, deleteAlbum, isLoadingAlbumInfo, getAlbumPosts, albumPosts, isLoadingAlbumPosts }) => {

    const [name, setName] = useState('')
    const [privacy, setPrivacy] = useState('')
    const [isShowModal, setIsShowModal] = useState(false)

    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            getAlbum(match.params.albumID)
        })

    }, [])
    useEffect(() => {
        getAlbumPosts({ albumID: match.params.albumID, entityID: match.params.userID })

        return () => {
            clearAlbumPosts()
        }
    }, [])


    if (isLoadingAlbumPosts)
        return <div>cargando...</div>
    else {
        return (
            <div className='content-list-social scroll-menu'>

                {albumPosts && albumPosts.map((post, index) =>
                    <>
                        {console.log()}
                         { (index === 0) ?
                            <div key={0} className="content-card-list content-card-list-plus" onClick={(e) => {
                                setIsShowModal(true)

                            }}>

                                <PlusIcon className="icon-new-story" />

                            </div> :
                            <div key={post._id} className="content-card-list" onClick={(e) => { e.stopPropagation(); }}>


                                <img alt="img" className="img-content-card-list-album" src={getAlbumData(post)}></img>

                            </div>


                        }

                    </>
                )}


                <ModalNewPost

                    nameUser={localStorage().getItem("nameUser")}
                    urlUser={localStorage().getItem("picturProfile")}
                    view='Home'
                    history={history}
                    displayModal={isShowModal}
                    closeModal={() => setIsShowModal(false)}
                    content={"new post"}
                    nameAlbum={albumInfo.name}
                    idAlbum={match.params.albumID}

                />
            </div>
        )
    }
}
const getAlbumData = (data) => {

    var viewData
    if (data.multimedia && data.multimedia.type) {
        if (data.multimedia?.type.includes('image'))
            viewData = data.multimedia.url && data.multimedia.url.medium ? data.multimedia.url.medium : data.multimedia.url.origin
        if (data.multimedia?.type.includes('video'))
            viewData = data.multimedia.url.thumbnail
        if (data.multimedia?.type.includes('audio'))
            viewData = audio
    }
    return viewData;

}
/*
///
    
    if (isLoadingAlbumInfo)
        return null
    else
        return (
            <div className="album-container">
                <div className="album-info-container">
                    <div className="row centerItems">
                        <div className="text-bold text-black text-fz-2">{albumInfo.name}</div>
                        <div className="">{new Date(albumInfo.creationDate).getFullYear() + ' ' + albumInfo.quantity + ' ' + Translate('records', 'es')}</div>
                    </div>
                    <div onClick={(e) => e.stopPropagation()} className="card-album-options">
                        <ModalMenu
                            contentButton={
                                <OptionsIcon className="black-svg mt-2 pointer" height="14" width="35" />
                            }
                            contentModal={<div className='modal-options row'>
                                <div onClick={() => {
                                    history.push({
                                        pathname: history.location.pathname.includes('Mark') ? '/Mark/EditAlbum' : '/EditAlbum',
                                        state: {
                                            album: albumInfo,
                                            idUser: match.params.userID
                                        }
                                    })
                                }} className="modal-options-album">  <EditIcon className="cls-1 mr-2" height="18" width="18" /> {Translate('edit', 'es')}</div>
                                <div onClick={() => { deleteAlbum(albumInfo._id, 0,history,false) }} className="modal-options-album">  <DeleteIcon className="cls-1 mr-2" height="18" width="18" /> {Translate('delete', 'es')}</div>
                            </div>}
                        />
                    </div>
                    <div onClick={() => history.go(-1)} className="back-icon-css">
                        <BackIcon className="cls-1" height="20" width="30" />
                    </div>
                </div>
                <div className="album-container-post">
                    <AlbumData idUser={match.params.userID} isMark={history.location.pathname.includes('Mark')} history={history} album={albumInfo} />
                </div>
            </div>
        )
}
*/
const mapStateToProps = (state) => {
    return {
        albumInfo: state.userInfo.albumInfo,
        isLoadingAlbumInfo: state.userInfo.isLoadingAlbumInfo,
        albumPosts: [ ...state.userInfo.albumPosts],
        isLoadingAlbumPosts: state.userInfo.isLoadingAlbumPosts
    }
}

export default connect(mapStateToProps, { getAlbum, editAlbum, clearAlbumPosts,deleteAlbum, getAlbumPosts })(Album)
